










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<LabelValue>({})
export default class LabelValue extends Vue {
  @Prop({ default: null })
  protected label!: string;

  @Prop({ default: null })
  protected value!: string;
}
